import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { CarouselType } from '../../../common';
import { CarouselViewModel } from '../carousel/carousel.view-model';
import { GenericCarouselViewModel } from './generic-carousel.view-model';

@Component({
  selector: 'osn-shared-generic-carousel',
  templateUrl: './generic-carousel.component.html',
  styleUrls: ['./generic-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericCarouselComponent {
  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
  private _vm: GenericCarouselViewModel;
  public carouselViewModel: CarouselViewModel;

  constructor() {}

  @Input() public set vm(vm: GenericCarouselViewModel) {
    this._vm = vm;
    this.carouselViewModel = {
      items: vm.items,
      layout: vm.layout,
      type: CarouselType.GenericCarousel,
      resolved: vm.resolved,
      readonlyMode: vm.readonlyMode,
      slug: vm.slug,
    };
  }

  public get vm() {
    return this._vm;
  }

  public get visible(): boolean {
    return !!this.vm && (!this.vm.resolved || (this.vm.resolved && this.vm.items && this.vm.items.length > 0));
  }

  @HostBinding('class.carousel-container')
  public get carouselContainerClass() {
    return this.visible;
  }
}
